export default __webpack_public_path__ + "static/media/43_desktop.fd97d4ee.jpg";